import {
  WorkflowApplicationActivityDataAudit,
  WorkflowApplicationEntityDataAudit
} from './workflow-application-activity-data-audit';

export class WorkflowApplicationActivityAuditDetails {
  activityInfo: WorkflowApplicationActivityDataAudit;
  entityDetails: WorkflowApplicationEntityDataAudit[];
}
